import { Grid, GridItem, Label, Text, useUIContext } from "@msuite/picasso";
import React from "react";
import type { TooltipProps } from "recharts";
import type { NameType, ValueType } from "recharts/types/component/DefaultTooltipContent";

/** Props Interface */
interface TooltipContentProps extends Omit<TooltipProps<ValueType, NameType>, "formatter"> {
	formatter?: (value: number) => string;
}

export function TooltipContent({ payload, label, formatter }: TooltipContentProps) {
	/** Context */
	const { colors } = useUIContext();

	/** Render */
	return (
		<Grid
			minW="200px"
			gridTemplateColumns="max-content 1fr"
			gap={2}
			px={3}
			py={2}
			rounded="xl"
			borderWidth={1}
			bg={colors.whiteAdjusted}
		>
			{label && (
				<React.Fragment>
					<GridItem colSpan={2}>
						<Text>{label}</Text>
					</GridItem>
				</React.Fragment>
			)}
			{payload?.map((entry) => (
				<React.Fragment key={entry.value?.toString()}>
					<Label>{entry.name}</Label>
					<Text textAlign="right">
						{formatter ? formatter(entry.value as number) : entry.value}
					</Text>
				</React.Fragment>
			))}
		</Grid>
	);
}
